export const LOADING_MONITOR = "LOADING_MONITOR";
export const SAVE_LOADING_MONITOR = "SAVE_LOADING_MONITOR";
export const GET_MONITOR = "GET_MONITOR";
export const GET_MONITOR_FAIL = "GET_MONITOR_FAIL";
export const COPIA_FAIL = "COPIA_FAIL";

export const LOADING_DADO_DE_BAJA = "LOADING_DADO_DE_BAJA";
export const SAVE_LOADING_DADO_DE_BAJA = "SAVE_LOADING_DADO_DE_BAJA";
export const DADO_DE_BAJA_FAIL = "DADO_DE_BAJA_FAIL";
export const GET_DADO_DE_BAJA = "GET_DADO_DE_BAJA";
